import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { useField } from 'formik';

import { Box } from '../../common/ui/Box';

import { RadioGroup } from './RadioGroup';

export const FormikRadioGroup = ({
    ...props
}: RadixRadioGroup.RadioGroupProps & {
    name: string;
}) => {
    const [field, meta, helpers] = useField({
        name: props.name,
        multiple: false,
    });

    return (
        <RadioGroup {...props} defaultValue={field.value} onValueChange={helpers.setValue}>
            {meta.touched && meta.error ? (
                <Box p={8} color="negative.foreground" border="default" borderColor="negative.border">
                    {meta.error}
                </Box>
            ) : null}
            {props.children}
        </RadioGroup>
    );
};
